export const isBesigne = (username: string | null | undefined): boolean => username?.toLowerCase() === "besigne";
export const canBuyCreditTopups = (username: string | null | undefined): boolean => !isBesigne(username);

export const BESIGNE_BADGES = [
  { label: "Friends w/ the Owner", glyph: "♔" },
  { label: "Death's Knight", glyph: "♘" },
  { label: "Closed Beta Tester", glyph: "♕" },
] as const;
